import "./currencyshapelist.css";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { Box } from "@mui/material";
import RoundedButton from "../../atomic/RoundedButton";
import { useTranslation } from "react-i18next";
import ChartIcon from "../../../assets/chart_icon_header.png";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

interface Currency {
  id: number;
  name: string;
  buy: number;
  sell: number;
  icon_link: string;
  abbreviation: string;
}

const CurrencyShapeList = () => {
  const { t } = useTranslation();
  const [currencies, setCurrencies] = useState<Currency[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchCurrencies = async () => {
      try {
        const response = await fetch(
          "https://api-panel.parsianbit.com/publish/v1/currency"
        );
        const data = await response.json();
        const fetchedCurrencies = data.data.currencies.slice(0, 3); // فقط سه ارز
        setCurrencies(fetchedCurrencies);
        setLoading(false);
      } catch (err) {
        setError("خطا در دریافت اطلاعات");
        setLoading(false);
      }
    };

    fetchCurrencies();
  }, []);

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Typography>{t("loading")}</Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Typography color="error">{error}</Typography>
      </Box>
    );
  }

  return (
    <Box className="second_section_shape">
      <Box className="second_section_shape_inner_1">
        <Grid container>
          {currencies.map((currency) => (
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              key={currency.id}
              sx={{
                display: "flex",
                justifyContent: { xs: "start", md: "center" },
                mt: { xs: 2, md: 0 },
              }}
            >
              <Stack direction={"row"} spacing={1.5}>
                <Box>
                  <img
                    src={currency.icon_link}
                    alt={currency.abbreviation}
                    width="100%"
                    style={{ borderRadius: "50%", marginTop: "-.4rem" }}
                  />
                </Box>
                <Stack direction={"column"} spacing={1.5}>
                  <Stack direction={"row"} spacing={1.5} alignItems={"center"}>
                    <Typography
                      variant="h6"
                      sx={{
                        textAlign: "start",
                        color: "#fff",
                      }}
                    >
                      {currency.abbreviation.toUpperCase()}
                    </Typography>
                  </Stack>
                  <Typography
                    variant="h6"
                    sx={{
                      textAlign: "start",
                      color: "#fff",
                    }}
                  >
                    قیمت خرید :{currency.buy.toLocaleString()} تومان
                  </Typography>
                  <Typography
                    variant="h6"
                    sx={{
                      textAlign: "start",
                      color: "#fff",
                    }}
                  >
                    قیمت فروش :{currency.sell.toLocaleString()} تومان
                  </Typography>
                </Stack>
              </Stack>
            </Grid>
          ))}
        </Grid>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "absolute",
            bottom: { xs: "-2%", sm: "-5%" },
            zIndex: 150,
            bgcolor: "#FF3DFF",
            width: "5rem",
            p: 2,
            borderRadius: "50px",
          }}
        >
          <Link to="https://panel.parsianbit.com/trade">{t("trade_now")} </Link>
        </Box>
      </Box>
      <svg
        className="tl-svg"
        width="100%"
        height="120"
        viewBox="0 0 1170 120"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0.345001V120H1170V0.423925C1169.96 16.045 1157.93 29.0247 1142.34 30.2459L586.348 73.816C584.785 73.9385 583.215 73.9383 581.652 73.8154L27.6483 30.2527C12.04 29.0254 0 16.0015 0 0.345001Z"
          fill="#35003a"
        />
      </svg>
    </Box>
  );
};

export default CurrencyShapeList;
